export function initAmbientePage() {

    if (!document.querySelector('.ambiente-hero-swiper')) {
        return;
    }

    initializeSwiper('.ambiente-hero-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
            enabled: true,
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    initializeSwiper('.chosen-products-swiper', {
        slidesPerView: 1.25,
        spaceBetween: 20,
        loop: false,
        navigation: {
            enabled: true,
            nextEl: '.swiper-chosenprod-nav-next',
            prevEl: '.swiper-chosenprod-nav-prev',
            addIcons: false
        },
        breakpoints: {
            576: {
                slidesPerView: 2.25,
            },
            992: {
                slidesPerView: 3.35,
            },
            1400: {
                slidesPerView: 4,
            },
        },
        scrollbar: {
            el: '.chosenprod-scrollbar-wrapper .swiper-scrollbar',
            draggable: true,
        },
    });

}